export default __webpack_public_path__ + "static/media/double-both-border-left.b4c1ac2e.svg";